<template>
  <div class="significance_report">
    <h2 style="text-align: center;padding-top:20px">{{data.analysisTitle}}</h2>
    <h3 style="margin-left:15px">1. 统计对象信息</h3>
    <p style="margin-left:35px; margin-top:10px">统计对象：{{data.deptName}}</p>
    <p style="margin-left:35px; margin-top:10px">量表名称: {{data.paperID}}</p>
    <p style="margin-left:35px; margin-top:10px">样本总体：总体均值{{data.conU}}总体标准差{{data.conS}}总体方差{{data.conV}} 最大值{{data.conMax}}  最小值{{data.conMin}}</p>
    <h3 style="margin-left:15px;margin-top:20px">2.部门_总分原始分显著性分析</h3>
    <!-- {{data}} -->
    
    <div v-for="(item,i) in list1" :key="i">
      <p style="text-align: center;padding-top:20px;padding-bottom:15px">{{item.tableName}}</p>
      <table style="width: calc(100% - 30px);margin-left:15px;">
        <tr>
          <td style="background-color: #d4fbf8;height: 30px;line-height: 30px;text-align:center" v-for="(item2,j) in item.columns" :key="j">{{item2}}</td>
        </tr>
        <tr v-for="(itenm3,a) in item.rows" :key="a">
          <td>{{}}</td>
          <td>18</td>
          <td>18</td>
          <td>18</td>
        </tr>
      </table>
    </div>
    
  </div>
</template>
<script>

export default {
  data() {
    return {
      data:'',
      list1:[],
      list2:[],
      list3:[],
    }
  },
  beforeCreate() {

  },
  methods: {

  },
  created() {
    
    this.$Http_Post('paper/analysis/getreport', {
      analysisKey:[this.$route.query.analysisKey][0],
    }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data =  res.Data;
        for(var i = 0;i<res.Data.tables.length;i++){
          if(res.Data.tables[i].tableName.slice(-1) == 'Z'){
            this.list1.push(res.Data.tables[i])
          }else if(res.Data.tables[i].tableName.slice(-1) == 'T'){
            this.list2.push(res.Data.tables[i])
          }else if(res.Data.tables[i].tableName.slice(-1) == 'F'){
            this.list3.push(res.Data.tables[i])
          }
        }
      }else{
        this.Global.request_failure(res.Message);
      }
    });
  },
}
</script>
<style>
.significance_report {width: 100%;height: 100%;background-image: url('../../assets/2bgc1227191745.png');background-size: 100% 100%;}
table {
    border-collapse: collapse;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-left-width: 1px;
    border-right-width: 1px;
}
tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}
td {
    display: table-cell;
    vertical-align: inherit;
    border: 1px solid;
    text-align: center;
    height: 30px;
    line-height: 30px;
}

</style>
